import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Bugsnag from "./config/bugsnag";
import { AuthProvider } from "./context/AuthContext";
import { AppLoadingProvider } from "./context/AppLoadingContext";
import App from "./App";
import { BugsnagFallback } from "./components/errors/BugsnagFallback";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
const ErrorBoundary = Bugsnag.getPlugin("react")?.createErrorBoundary(React);

const appTree = (
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppLoadingProvider>
          <App />
        </AppLoadingProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

root.render(
  ErrorBoundary ? <ErrorBoundary FallbackComponent={BugsnagFallback}>{appTree}</ErrorBoundary> : appTree,
);
